(function () {
  function qsa(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }

  function qs(selector, scope) {
    return (scope || document).querySelector(selector);
  }

  function initAnnouncement() {
    var root = qs("[data-akt-announcement]");
    if (!root) return;

    var slides = qsa(".announcement-bar__message", root);
    var dots = qsa("[data-akt-announcement-dot]", root);
    var index = 0;

    function show(next) {
      index = next;
      slides.forEach(function (slide, i) {
        slide.classList.toggle("is-active", i === index);
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle("is-active", i === index);
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener("click", function () {
        show(Number(dot.getAttribute("data-akt-announcement-dot")) || 0);
      });
    });

    show(0);
    if (slides.length > 1) {
      window.setInterval(function () {
        show((index + 1) % slides.length);
      }, 3500);
    }
  }

  function initMobileMenu() {
    var drawer = qs("[data-akt-mobile-drawer]");
    var open = qs("[data-akt-menu-open]");
    var close = qs("[data-akt-menu-close]");
    if (!drawer || !open || !close) return;

    open.addEventListener("click", function () {
      drawer.hidden = false;
      document.body.classList.add("overflow-hidden");
    });

    function hideDrawer() {
      drawer.hidden = true;
      document.body.classList.remove("overflow-hidden");
    }

    close.addEventListener("click", hideDrawer);
    drawer.addEventListener("click", function (event) {
      if (event.target === drawer) hideDrawer();
    });
  }

  function initGallery() {
    qsa("[data-akt-gallery]").forEach(function (gallery) {
      var main = qs("[data-akt-main-image]", gallery);
      var thumbs = qsa("[data-akt-thumb]", gallery);
      var currentEl = qs("[data-akt-gallery-current]", gallery);
      var index = 0;

      function show(next) {
        if (!thumbs.length) return;
        index = (next + thumbs.length) % thumbs.length;
        thumbs.forEach(function (item, i) {
          item.classList.toggle("is-active", i === index);
        });
        if (main) {
          main.src = thumbs[index].getAttribute("data-image") || main.src;
        }
        if (currentEl) currentEl.textContent = String(index + 1);
      }

      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener("click", function () {
          show(i);
        });
      });

      var prev = qs("[data-akt-gallery-prev]", gallery);
      var next = qs("[data-akt-gallery-next]", gallery);
      if (prev) prev.addEventListener("click", function () { show(index - 1); });
      if (next) next.addEventListener("click", function () { show(index + 1); });
    });
  }

  function initPlan() {
    qsa("[data-akt-plan]").forEach(function (root) {
      qsa("[data-akt-plan-option]", root).forEach(function (opt) {
        opt.addEventListener("click", function () {
          qsa("[data-akt-plan-option]", root).forEach(function (item) {
            item.classList.remove("active");
          });
          opt.classList.add("active");
        });
      });
    });
  }

  function initProductForm() {
    qsa("[data-akt-product-form]").forEach(function (form) {
      var variantInput = qs("[data-akt-variant-input]", form);
      var mainImage = qs("[data-akt-main-image]");
      var price = qs("[data-akt-price]");
      var compare = qs("[data-akt-compare]");
      var qtyInput = qs("[data-akt-qty-input]", form);

      qsa("[data-akt-variant-button]", form).forEach(function (button) {
        button.addEventListener("click", function () {
          qsa("[data-akt-variant-button]", form).forEach(function (item) {
            item.classList.remove("is-active");
          });
          button.classList.add("is-active");

          if (variantInput) {
            variantInput.value = button.getAttribute("data-variant-id");
          }

          if (price) {
            price.textContent = button.getAttribute("data-price") || price.textContent;
          }

          if (compare) {
            var compareValue = button.getAttribute("data-compare");
            compare.textContent = compareValue || "";
            compare.parentElement.hidden = !compareValue;
          }

          if (mainImage && button.getAttribute("data-image")) {
            mainImage.src = button.getAttribute("data-image");
          }
          var row = button.closest(".scent-item");
          if (row) {
            qsa(".scent-item", form).forEach(function (item) {
              item.classList.toggle("is-active", item === row);
            });
          }
        });
      });

      qsa("[data-akt-qty]", form).forEach(function (button) {
        button.addEventListener("click", function () {
          if (!qtyInput) return;
          var next = parseInt(qtyInput.value || "1", 10) + parseInt(button.getAttribute("data-akt-qty"), 10);
          qtyInput.value = String(Math.max(1, next));
        });
      });
    });
  }

  function initAccordions() {
    qsa("[data-akt-accordion]").forEach(function (item) {
      item.addEventListener("toggle", function () {
        if (!item.open) return;
        var group = item.parentElement;
        if (!group) return;
        qsa("[data-akt-accordion]", group).forEach(function (sibling) {
          if (sibling !== item) sibling.removeAttribute("open");
        });
      });
    });
  }

  function initTabs() {
    qsa("[data-akt-tabs]").forEach(function (root) {
      var buttons = qsa("[data-akt-tab]", root);
      var panels = qsa("[data-akt-panel]", root);

      buttons.forEach(function (button) {
        button.addEventListener("click", function () {
          var target = button.getAttribute("data-akt-tab");
          buttons.forEach(function (item) {
            item.classList.toggle("is-active", item === button);
          });
          panels.forEach(function (panel) {
            panel.classList.toggle("is-active", panel.getAttribute("data-akt-panel") === target);
          });
        });
      });
    });
  }

  function initSlideshows() {
    qsa("[data-akt-slideshow]").forEach(function (root) {
      var slides = qsa("[data-akt-slides] > *", root);
      var dotsRoot = qs("[data-akt-slideshow-dots]", root);
      if (!slides.length || !dotsRoot) return;

      var index = 0;
      var mobile = window.matchMedia("(max-width: 989px)");

      function renderDots() {
        dotsRoot.innerHTML = "";
        if (!mobile.matches) return;

        slides.forEach(function (_, i) {
          var button = document.createElement("button");
          button.type = "button";
          button.className = i === index ? "is-active" : "";
          button.addEventListener("click", function () {
            index = i;
            update();
          });
          dotsRoot.appendChild(button);
        });
      }

      function update() {
        slides.forEach(function (slide, i) {
          if (mobile.matches) {
            slide.hidden = i !== index;
          } else {
            slide.hidden = false;
          }
        });

        qsa("button", dotsRoot).forEach(function (button, i) {
          button.classList.toggle("is-active", i === index);
        });
      }

      renderDots();
      update();
      mobile.addEventListener("change", function () {
        index = 0;
        renderDots();
        update();
      });
    });
  }

  function initReveal() {
    var targets = qsa(".multicolumn-card, .image-with-text__content, .card-wrapper");
    if (!targets.length || !("IntersectionObserver" in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    targets.forEach(function (target) {
      target.classList.add("akt-reveal");
      observer.observe(target);
    });
  }

  function initScentShow() {
    var root = qs("[data-akt-scent-show]");
    if (!root) return;
    var slides = qsa("[data-akt-scent-slide]", root);
    var dotsRoot = qs("[data-akt-scent-dots]", root);
    var prev = qs("[data-akt-scent-prev]", root);
    var next = qs("[data-akt-scent-next]", root);
    if (!slides.length) return;
    var index = 0;

    slides.forEach(function (_, i) {
      var dot = document.createElement("button");
      dot.type = "button";
      dot.setAttribute("aria-label", "Slide " + (i + 1));
      dot.addEventListener("click", function () {
        index = i;
        render();
      });
      dotsRoot.appendChild(dot);
    });

    function render() {
      slides.forEach(function (slide, i) {
        var on = i === index;
        slide.classList.toggle("is-on", on);
        slide.hidden = !on;
      });
      qsa("button", dotsRoot).forEach(function (dot, i) {
        dot.classList.toggle("is-on", i === index);
      });
    }

    if (prev) prev.addEventListener("click", function () {
      index = (index - 1 + slides.length) % slides.length;
      render();
    });
    if (next) next.addEventListener("click", function () {
      index = (index + 1) % slides.length;
      render();
    });
    render();
  }

  function initReviewShow() {
    var root = qs("[data-akt-review-show]");
    if (!root) return;
    var track = qs("[data-akt-review-track]", root);
    var cards = qsa(".akt-review-card", track);
    var dotsRoot = qs("[data-akt-review-dots]", root);
    var prev = qs("[data-akt-review-prev]", root);
    var next = qs("[data-akt-review-next]", root);
    if (!track || !cards.length) return;
    var index = 0;

    function visibleCount() {
      return window.matchMedia("(min-width: 990px)").matches ? 3 : 1;
    }

    function maxIndex() {
      return Math.max(0, cards.length - visibleCount());
    }

    function renderDots() {
      if (!dotsRoot) return;
      dotsRoot.innerHTML = "";
      var pages = maxIndex() + 1;
      for (var i = 0; i < pages; i++) {
        var dot = document.createElement("button");
        dot.type = "button";
        dot.setAttribute("aria-label", "Reviews " + (i + 1));
        (function (page) {
          dot.addEventListener("click", function () {
            index = page;
            render();
          });
        })(i);
        dotsRoot.appendChild(dot);
      }
    }

    function render() {
      if (index > maxIndex()) index = maxIndex();
      if (index < 0) index = 0;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || "0") || 0;
      var width = cards[0].getBoundingClientRect().width;
      track.style.transform = "translateX(" + (-index * (width + gap)) + "px)";
      if (dotsRoot) {
        qsa("button", dotsRoot).forEach(function (dot, i) {
          dot.classList.toggle("is-on", i === index);
        });
      }
    }

    if (prev) prev.addEventListener("click", function () {
      index = index <= 0 ? maxIndex() : index - 1;
      render();
    });
    if (next) next.addEventListener("click", function () {
      index = index >= maxIndex() ? 0 : index + 1;
      render();
    });
    window.addEventListener("resize", function () {
      renderDots();
      render();
    });
    renderDots();
    render();
  }

  function initScentFilter() {
    qsa("[data-akt-scent-picker]").forEach(function (root) {
      var buttons = qsa("[data-akt-scent-filter]", root);
      var items = qsa(".scent-item", root);
      buttons.forEach(function (button) {
        button.addEventListener("click", function () {
          var filter = button.getAttribute("data-akt-scent-filter") || "all";
          buttons.forEach(function (item) {
            item.classList.toggle("is-active", item === button);
          });
          items.forEach(function (item) {
            var tags = (item.getAttribute("data-filter") || "").toLowerCase();
            var show = filter === "all" || tags.indexOf(filter.toLowerCase()) !== -1;
            item.classList.toggle("is-hidden", !show);
          });
        });
      });
    });
  }

  function initReasons() {
    var root = qs("[data-akt-reasons]");
    if (!root) return;
    var track = qs("[data-akt-reasons-track]", root);
    var cards = qsa(".akt-reasons__card", track);
    var dotsRoot = qs("[data-akt-reasons-dots]", root);
    var prev = qs("[data-akt-reasons-prev]", root);
    var next = qs("[data-akt-reasons-next]", root);
    if (!track || !cards.length) return;
    var index = 0;

    function visibleCount() {
      return window.matchMedia("(min-width: 990px)").matches ? 3 : 1;
    }

    function maxIndex() {
      return Math.max(0, cards.length - visibleCount());
    }

    function renderDots() {
      if (!dotsRoot) return;
      dotsRoot.innerHTML = "";
      var pages = maxIndex() + 1;
      for (var i = 0; i < pages; i++) {
        var dot = document.createElement("button");
        dot.type = "button";
        dot.setAttribute("aria-label", "Reasons " + (i + 1));
        (function (page) {
          dot.addEventListener("click", function () {
            index = page;
            render();
          });
        })(i);
        dotsRoot.appendChild(dot);
      }
    }

    function render() {
      if (index > maxIndex()) index = maxIndex();
      if (index < 0) index = 0;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || "0") || 0;
      var width = cards[0].getBoundingClientRect().width;
      track.style.transform = "translateX(" + (-index * (width + gap)) + "px)";
      if (dotsRoot) {
        qsa("button", dotsRoot).forEach(function (dot, i) {
          dot.classList.toggle("is-on", i === index);
        });
      }
    }

    if (prev) prev.addEventListener("click", function () {
      index = index <= 0 ? maxIndex() : index - 1;
      render();
    });
    if (next) next.addEventListener("click", function () {
      index = index >= maxIndex() ? 0 : index + 1;
      render();
    });
    window.addEventListener("resize", function () {
      renderDots();
      render();
    });
    renderDots();
    render();
  }

  function initTrials() {
    var root = qs("[data-akt-trials]");
    if (!root) return;
    var slides = qsa("[data-akt-trial-slide]", root);
    var dotsRoot = qs("[data-akt-trial-dots]", root);
    var prev = qs("[data-akt-trial-prev]", root);
    var next = qs("[data-akt-trial-next]", root);
    if (!slides.length) return;
    var index = 0;

    slides.forEach(function (_, i) {
      var dot = document.createElement("button");
      dot.type = "button";
      dot.setAttribute("aria-label", "Trial " + (i + 1));
      dot.addEventListener("click", function () {
        index = i;
        render();
      });
      dotsRoot.appendChild(dot);
    });

    function render() {
      slides.forEach(function (slide, i) {
        var on = i === index;
        slide.classList.toggle("is-on", on);
        slide.hidden = !on;
      });
      qsa("button", dotsRoot).forEach(function (dot, i) {
        dot.classList.toggle("is-on", i === index);
      });
    }

    if (prev) prev.addEventListener("click", function () {
      index = (index - 1 + slides.length) % slides.length;
      render();
    });
    if (next) next.addEventListener("click", function () {
      index = (index + 1) % slides.length;
      render();
    });
    render();
  }

  function initLoveReviews() {
    var root = qs("[data-akt-love]");
    if (!root) return;
    var items = qsa(".akt-love__item", root);
    var search = qs("[data-akt-love-search]", root);
    var sort = qs("[data-akt-love-sort]", root);
    var more = qs("[data-akt-love-more]", root);
    var write = qs("[data-akt-love-write]", root);
    var form = qs("[data-akt-love-form]", root);
    var page = 5;
    var starFilter = "all";

    function visiblePool() {
      var q = ((search && search.value) || "").toLowerCase();
      var pool = items.filter(function (item) {
        var stars = item.getAttribute("data-stars") || "";
        var text = (item.getAttribute("data-text") || item.textContent || "").toLowerCase();
        var okStar = starFilter === "all" || stars === starFilter;
        var okText = !q || text.indexOf(q) !== -1;
        return okStar && okText;
      });
      var mode = (sort && sort.value) || "highest";
      pool.sort(function (a, b) {
        var as = parseInt(a.getAttribute("data-stars") || "0", 10);
        var bs = parseInt(b.getAttribute("data-stars") || "0", 10);
        var ad = a.getAttribute("data-date") || "";
        var bd = b.getAttribute("data-date") || "";
        if (mode === "lowest") return as - bs;
        if (mode === "newest") return bd.localeCompare(ad);
        if (bs !== as) return bs - as;
        return bd.localeCompare(ad);
      });
      return pool;
    }

    function render() {
      var pool = visiblePool();
      items.forEach(function (item) { item.hidden = true; });
      pool.slice(0, page).forEach(function (item) { item.hidden = false; });
      if (more) more.hidden = pool.length <= page;
    }

    if (search) search.addEventListener("input", function () { page = 5; render(); });
    if (sort) sort.addEventListener("change", function () { page = 5; render(); });
    if (more) more.addEventListener("click", function () { page += 5; render(); });
    qsa("[data-akt-love-star]", root).forEach(function (button) {
      button.addEventListener("click", function () {
        var next = button.getAttribute("data-akt-love-star") || "all";
        starFilter = starFilter === next ? "all" : next;
        qsa("[data-akt-love-star]", root).forEach(function (row) {
          row.classList.toggle("is-on", row.getAttribute("data-akt-love-star") === starFilter);
        });
        page = 5;
        render();
      });
    });
    qsa("[data-akt-love-helpful]", root).forEach(function (button) {
      button.addEventListener("click", function () {
        var n = parseInt(button.getAttribute("data-count") || "0", 10) + 1;
        button.setAttribute("data-count", String(n));
        button.textContent = "Helpful " + n;
      });
    });
    if (write && form) {
      write.addEventListener("click", function () {
        form.hidden = !form.hidden;
      });
    }
    render();
  }

  function initHowto() {
    qsa("[data-akt-howto]").forEach(function (root) {
      var button = qs("[data-akt-howto-play]", root);
      var video = qs("video", root);
      if (!button || !video) return;
      button.addEventListener("click", function () {
        root.classList.add("is-playing");
        video.hidden = false;
        video.play();
      });
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initAnnouncement();
    initMobileMenu();
    initGallery();
    initPlan();
    initProductForm();
    initAccordions();
    initTabs();
    initSlideshows();
    initReveal();
    initScentShow();
    initReviewShow();
    initScentFilter();
    initHowto();
    initReasons();
    initTrials();
    initLoveReviews();
  });
})();
